import { Link, useLocation, useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { getUserDetailsStore, pages, PagesType, setUserDetailsStore } from "..";
import { DP } from "../../../common/types";

interface Props extends DP {}

const Navigation = (props: Props) => {
  return (
    <Wrapper className={props.className}>
      {Object.keys(pages).map((el: any) => (
        <NavLinkC page={el} />
      ))}
    </Wrapper>
  );
};

const NavLinkC = (props: { page: PagesType }) => {
  const { pathname } = useLocation();
  const { username } = useParams();
  const { currentPage } = getUserDetailsStore();

  const isCurrent =
    pathname.slice(1).replaceAll("/", "") ==
    pages[props.page].location(username).replaceAll("/", "");
  if (isCurrent && currentPage != props.page) {
    setUserDetailsStore({ currentPage: props.page });
  }

  const { icon: Icon, title } = pages[props.page];

  const handleClick = () => {
    setUserDetailsStore({ isFetching: true, posts: [], page: 0 });
  };

  return (
    <NavLink
      replace
      to={"../" + pages[props.page].location(username)}
      isCurrent={isCurrent}
      onClick={handleClick}
    >
      <Icon />
      <span>{title}</span>
    </NavLink>
  );
};

const Wrapper = styled.div(() => [
  tw`flex w-full text-pink-600 text-[0.4rem] border-b-2 space-x-2`,
  css`
    ${tw`border-gray-400`}
    border-style: none none solid none;
    border-color: rgba(0, 0, 0, 0.1);
  `,
]);

const NavLink = styled(Link)(({ isCurrent }: { isCurrent: boolean }) => [
  tw`py-1 flex  box-content items-center space-x-0.5`,
  isCurrent &&
    css`
      box-shadow: 0 2px 0 0px;
      ${tw`shadow-pink-400`}
    `,
  css`
    @media (hover: hover) {
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
    }
  `,
]);

export default styled(Navigation)``;
